import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { AlertCategory } from "../models/entities/alert-category.model";
import { DEFAULT_ALERT_CATEGORIES } from "../config/alert-categories.config";

const QUERY_KEY = ["alert-categories"];

export const useAlertCategories = () => {
	const queryClient = useQueryClient();

	const query = useQuery({
		queryKey: QUERY_KEY,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getAlertCategories({});
			return response as AlertCategory[];
		},
	});

	return {
		...query,
		data: query.data ?? DEFAULT_ALERT_CATEGORIES,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: QUERY_KEY,
			}),
	};
};
